import { useContext, useEffect } from 'react'
// import Button from 'components/button'
import { LoaderContext } from 'contexts/loader-context'
import useMainClass from 'hooks/use-main-cass'
import { ButtonVariant } from 'components/generic-error/components/button'
import { useHistory } from 'react-router-dom'
import ButtonCloseMenu from 'components/button-close'

const StepThree = () => {
  const history = useHistory()

  useMainClass('indio-popup-cp')

  const { setFooter } = useContext(LoaderContext)
  useEffect(() => {
    setFooter(false)
    return () => setFooter(true)
  }, [])

  const handleClick = () => {
    history.push('/album/redirect/Foto/upload')
  }

  return (
    <div className='w-full h-full cp-step-three flex justify-between flex-col px-5' style={{ background: '#005943' }}>
      <ButtonCloseMenu
        open={true}
        paramFn={() => {
          gtag('event', 'Click', {
            event_category: GTM_EVENT_CATEGORY,
            event_label: 'Survey - Cerrar modal',
            value: '10'
          })
          history.goBack();
        }}
      />
      <div className='flex flex-1 flex-col justify-center items-center gap-2'>
        <h2>
          ¡genial! <br /> has nominado tu código postal
        </h2>
        <p style={{ maxWidth: '281px' }}>
          Ya puedes generar el diseño de tu corriente urbana y subirlo en la dinámica.
        </p>
      </div>
      <div className='mb-10'>
        <ButtonVariant className="w-full" onClick={handleClick}>Subir mi diseño</ButtonVariant>
        <p className="text-center mt-2 underline cursor-pointer font-medium uppercase" style={{ fontFamily: 'Raleway', fontSize: '10px' }} onClick={() => history.push('/home')}>
          SALIR
        </p>
      </div>
    </div>
  )
}

export default StepThree